<div class="toggle-container" [class.toggle-disabled]="disabled">
  <div *ngFor="let opt of toggleOptions" class="d-flex gap-2">
    <input
      type="radio"
      [id]="controlIdPrefix + '-' + opt.label"
      class="visually-hidden toggle-input"
      [checked]="selectedValue === opt.value"
      [disabled]="disabled"
      (change)="onChange(opt.value)" /><label [for]="controlIdPrefix + '-' + opt.label" class="toggle-label">{{
      opt.label
    }}</label>
  </div>
</div>
